module.exports = __webpack_public_path__ + "img/_icon-hold-mail.4a50be85.svg";